import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
/**
 * Catches uncaught render/effect errors in its subtree. Without this, a single
 * page-level bug (undefined access on socket payload, parse failure, etc.)
 * unmounts the whole React tree and leaves the user with a blank document.
 *
 * Place at App root for catastrophic failures and around the route outlet so
 * a broken page doesn't kill the sidebar/channel-switcher.
 */
export class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        // Log to console so it's available in DevTools; production builds should
        // wire this to a real error reporter (Sentry/etc) later.
        console.error("ErrorBoundary caught:", error, info);
    }
    reset = () => {
        this.setState({ error: null });
    };
    render() {
        if (!this.state.error)
            return this.props.children;
        return (_jsx("div", { className: "dark flex h-full flex-col items-center justify-center gap-4 bg-background p-6 text-foreground", role: "alert", children: _jsxs("div", { className: "max-w-lg space-y-4 text-center", children: [_jsx("h2", { className: "text-xl font-semibold text-destructive", children: "Diese Seite ist abgest\u00FCrzt" }), _jsxs("p", { className: "text-sm text-muted-foreground", children: ["Ein unerwarteter Fehler ist aufgetreten", this.props.scope ? ` in: ${this.props.scope}` : "", ". Du kannst die Seite neu laden oder \u00FCber die Sidebar weiterarbeiten."] }), _jsx("pre", { className: "rounded-md border border-destructive/30 bg-destructive/10 p-3 text-left text-xs text-destructive overflow-auto max-h-48", children: this.state.error.message }), _jsxs("div", { className: "flex justify-center gap-2", children: [_jsx("button", { onClick: this.reset, className: "rounded-md border border-input bg-background px-4 py-2 text-sm hover:bg-accent", children: "Erneut versuchen" }), _jsx("button", { onClick: () => window.location.reload(), className: "rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground hover:bg-primary/90", children: "Seite neu laden" })] })] }) }));
    }
}
